import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.CUSTOMERS}/Customers`;




async function search(payload) {
  
  try {
    let response = await api.get(`${basePath}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "clientService.search"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "clientService.search");
    return null;
  }
}

async function fetchClient(id) {
  try {
    let response = await api.get(`${basePath}/${id}`);

    let treated = errorHandling.handleResponse(
      response,
      "clientService.fetchClient"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "clientService.fetchClient");
    return null;
  }
}


export const clientService = {
  search,
  fetchClient
};
